export default __webpack_public_path__ + "static/media/SubjectCharts.f63eff0b.png";